import React from 'react';

const Job_Replacements = () => {
    return (
        <div>Job_Replacements Component</div>
    );
}

export default Job_Replacements;
